import { render } from "./SimpleRendererConfig.vue?vue&type=template&id=773f9142"
import script from "./SimpleRendererConfig.vue?vue&type=script&lang=js"
export * from "./SimpleRendererConfig.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__